import { struct, u8 } from "@solana/buffer-layout";
import type { PublicKey } from "@solana/web3.js";
import { TransactionInstruction } from "@solana/web3.js";

import { TokenSwapInstruction } from "./instruction";

interface Data {
  instruction: number;
}

const DataLayout = struct<Data>([u8("instruction")]);

export const pauseInstruction = (
  programId: PublicKey,
  tokenSwapKey: PublicKey,
  authority: PublicKey
): TransactionInstruction => {
  const data = Buffer.alloc(DataLayout.span);
  DataLayout.encode(
    {
      instruction: TokenSwapInstruction.Pause,
    },
    data
  );
  const keys = [
    { pubkey: tokenSwapKey, isSigner: false, isWritable: true },
    { pubkey: authority, isSigner: true, isWritable: false },
  ];

  return new TransactionInstruction({
    keys,
    programId,
    data,
  });
};
